function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEBookStar = function SvgEBookStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60488"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60489"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17704",
    d: "M18 7.088v21.667m0-21.667A13.672 13.672 0 0 0 10.5 5 13.672 13.672 0 0 0 3 7.088v21.667a13.672 13.672 0 0 1 7.5-2.088 13.672 13.672 0 0 1 7.5 2.088m15-14.329v14.329a13.668 13.668 0 0 0-7.5-2.088 13.672 13.672 0 0 0-7.5 2.088",
    transform: "translate(1 2.122)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 2",
    d: "m6 0 2.1 3.594 3.9.989-2.6 3.211L9.708 12 6 10.39 2.292 12 2.6 7.794 0 4.584l3.9-.989z",
    transform: "translate(23 2)",
    style: {
      fill: "currentColor"
    }
  }))));
};

export default SvgEBookStar;